/**
 * FancyCard.js
 * A card component, with fancy transitional animations and statusbar.
 *
 * @class FancyCard
 * @author  Yevgeniy Rokhlin
 *
 */

import  React from 'react';
import	Paper from 'components/paper/Paper';
import	Transition from 'components/transition-groups/Transition';

export default React.createClass({

	displayName: "FancyCard",

	propTypes: {
		headerTitle: React.PropTypes.string,
		headerSubtitle: React.PropTypes.string,
		headerStatus: React.PropTypes.string, //primary, success, warning
		headerStatusBarText: React.PropTypes.any,
		onHeaderStatusBarClick: React.PropTypes.func,
		customHeader: React.PropTypes.any,
		customHeaderClass: React.PropTypes.string,
		transitionType: React.PropTypes.string,
		transitionDirection: React.PropTypes.string, //transitionDirection of the titles (up,down,left,right)
		depth: React.PropTypes.number
	},

	getDefaultProps() {
		return {
			depth: 1,
			transitionDirection: 'up',
			customHeaderClass: '',
			headerStatus: 'default'

		};
	},

	getInitialState() {
		return ({
			headerTitle: this.props.headerTitle,
			headerSubtitle: this.props.headerSubtitle,
			headerStatusBarText: this.props.headerStatusBarText,
			headerStatus: this.props.headerStatus,
			showHeaderStatusBar: false, //has to FancyCard has to render before statusbar can be shown.
			customHeader: this.props.customHeader
		});
	},

	render() {

		/**
		 * Determine headerStatusBar height and put an opposite
		 * value in the headerTitleGroup's marginTop inline style.
		 */
		let headerTitleGroupStyle;

		if (this.state.showHeaderStatusBar){
			headerTitleGroupStyle = {
				marginTop: this._headerStatusBarHeight() * -1 + 'px'
			};
		} else {
			headerTitleGroupStyle = {
					marginTop: '0px'
			};
		};

		let customHeaderKey;

		if (this.props.customHeader){
			customHeaderKey = this.state.customHeader[0].key;
		};

		let customHeader = (
			<div ref="headerTitleGroup" style={headerTitleGroupStyle} className="lui-fancy-card-header-title-group">
				<Transition type="slide-in" direction={this.props.transitionDirection}>
					<div key={customHeaderKey} className={`lui-fancy-card-custom-header ${this.props.customHeaderClass}`}>
						{this.state.customHeader}
					</div>
				</Transition>
			</div>
		);

		let standardHeader = (
		<div ref="headerTitleGroup" style={headerTitleGroupStyle} className="lui-fancy-card-header-title-group">
			<Transition type="slide-in" className="lui-fancy-card-header-container" direction={this.props.transitionDirection}>
				<div key={this.state.headerTitle} className="lui-fancy-card-header-title lui-font-style-headline">
					{this.state.headerTitle}
				</div>
			</Transition>
			<Transition type="slide-in" className="lui-fancy-card-header-container" direction={this.props.transitionDirection}>
				<div key={this.state.headerSubtitle} className="lui-fancy-card-header-subtitle lui-font-style-subhead-1">
					{this.state.headerSubtitle}
				</div>
			</Transition>
		</div>
		);

		// If a custom header is supplied, render it instead of the standard header.
		let header = this.props.customHeader ? customHeader : standardHeader;

		return (
			<div id="lui-fancy-card">
				<Paper padded={true} depth={this.props.depth} innerClassName="lui-fancy-card-inner">
					<div className={`lui-fancy-card-header ${this.state.headerStatus}`}>
							
							{header}
						<div ref="headerStatusBar" onClick={this._handleHeaderStatusBarClick} className="lui-fancy-card-header-statusbar">
							{this.props.headerStatusBarText}
						</div>

					</div>
					
					<div>
						<div className="lui-fancy-card-tools">
								{this.props.tools}
						</div>
					</div>
					<div className="lui-fancy-card-body">
						{this.props.children}
					</div>
				</Paper>
			</div>
		);
	},


	toggleHeaderStatusBar() {

		this.setState({
			showHeaderStatusBar: !this.state.showHeaderStatusBar,
		});

	},

	showHeaderStatusBar() {

		this.setState({
			showHeaderStatusBar: true
		});

	},

	hideHeaderStatusBar() {

		this.setState({
			showHeaderStatusBar: false
		});

	},

	setHeaderStatus(status) {
		this.setState({
			headerStatus: status
		})
	},

	/**
	 * Determines height of the headerStatusBar and returns it.
	 * @return {number}
	 */
	_headerStatusBarHeight() {

		let headerStatusBar = React.findDOMNode(this.refs.headerStatusBar)

		return headerStatusBar.offsetHeight;
	},

	_handleHeaderStatusBarClick() {

		if (this.props.onHeaderStatusBarClick) {
			this.props.onHeaderStatusBarClick();
		} else {
			this.hideHeaderStatusBar();
		};
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/cards/fancy-card/FancyCard.js
 **/